/**
 * V5.1 — Kompakte Marktphasen-Pille für Header (Watchlist, Symbol-Detail).
 * Zeigt die aktuelle Phase als kleinen farbigen Badge mit Hover-Tooltip.
 */

import type { MarketPhaseInput } from '@/lib/v51/market-phase';
import { computeMarketPhase } from '@/lib/v51/market-phase';
import { cn } from '@/lib/utils';

interface Props {
  input: MarketPhaseInput | null;
}

const PHASE_LABEL = {
  bull: 'Bull',
  korrektur: 'Korrektur',
  bear: 'Bear',
  accumulation: 'Akkumulation',
  neutral: 'Neutral',
} as const;

const PHASE_CLS = {
  bull: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-300',
  korrektur: 'border-orange-500/40 bg-orange-500/10 text-orange-300',
  bear: 'border-red-500/40 bg-red-500/10 text-red-300',
  accumulation: 'border-sky-500/40 bg-sky-500/10 text-sky-300',
  neutral: 'border-amber-500/40 bg-amber-500/10 text-amber-300',
} as const;

export function MarketPhasePill({ input }: Props) {
  if (!input) {
    return (
      <span className="rounded-md border border-zinc-700 bg-zinc-900/40 px-2 py-0.5 text-[11px] text-zinc-500">
        Marktphase …
      </span>
    );
  }
  const result = computeMarketPhase(input);
  const label = PHASE_LABEL[result.aggregate];
  const cls = PHASE_CLS[result.aggregate];

  return (
    <span
      className={cn('rounded-md border px-2 py-0.5 text-[11px] font-medium', cls)}
      title={result.summary}
    >
      Marktphase: {label}
    </span>
  );
}
